export interface State {
  items: {
    question: string
    answer: string
    isOpen: boolean
  }[]
}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  items: [
    {
      question: 'どうやったらポイントを貯められますか？',
      answer:
        '現時点でのポイントの貯め方は「試合開催日にスタジアムでチェックイン」「指定ハッシュタグを付けてTwitterでツイート」「レッズ飯店舗でチェックイン」の3パターンです。\n浦和レッズの試合に足を運んで、Twitterに投稿、帰りはレッズ飯店舗でカンパイ、という流れで浦和レッズを応援することで、スムーズに貯めることができます！',
      isOpen: false
    },
    {
      question: 'スタジアムでのチェックインの条件は？',
      answer:
        '埼玉スタジアム2002にて浦和レッズの公式試合が行われる日限定で、埼玉スタジアム2002にてチェックインができます。\nまた、浦和駒場スタジアムで浦和レッズレディースの公式試合が行われる日は、浦和駒場スタジアムにてチェックインができます。\nスタジアムに近づいていただき、キャンペーンサイトの「チェックイン」ボタンを押すと、チェックイン可能な場所が表示されます。同じ場所でチェックインできるのは1日1回です。\nチェックインをすると、10ポイントもらえます。',
      isOpen: false
    },
    {
      question: 'Twitterでポイントをもらうには？',
      answer:
        '設定画面から「Twitter連動」ボタンを押して、連携処理を行ってください。\n連携したTwitterアカウントで「#浦和レッズ公式ビール一番搾り」または「#レッズ飯」をつけてツイートすると、1時間以内に10ポイントがもらえます。\nなお、スタジアムビールの映える写真など、素敵な写真を載せて応援すると追加でポイントがもらえます！\n\nポイントがもらえるのは、ひとつのハッシュタグにつき一人1日1回までです。\n\n[#浦和レッズ公式ビール一番搾り](https://twitter.com/intent/tweet?hashtags=%e6%b5%a6%e5%92%8c%e3%83%ac%e3%83%83%e3%82%ba%e5%85%ac%e5%bc%8f%e3%83%93%e3%83%bc%e3%83%ab%e4%b8%80%e7%95%aa%e6%90%be%e3%82%8a)\n[#レッズ飯](https://twitter.com/intent/tweet?hashtags=%e3%83%ac%e3%83%83%e3%82%ba%e9%a3%af)',
      isOpen: false
    },
    {
      question: 'ツイートしたのにポイントが届かない',
      answer:
        'Twitter連携でのポイントが届くまでに、最大1時間程度かかります。\nそれ以上たっても加算されない場合、アカウントの連携が正しくできていない可能性がありますので再度連携いただくか、[お問い合わせ](https://forms.gle/us4QCrEDu4ZJ7dNY6)ください。\n\nまた、同じハッシュタグでのポイント付与は一人1日1回までですので、ご了承下さい。',
      isOpen: false
    },
    {
      question: 'レッズ飯とは？',
      answer:
        'レッズ飯とは、浦和レッズを応援するお店によるオリジナルメニューのことです。レッズ飯を提供している店舗に行って、チェックインボタンからチェックインを行うと、10ポイントもらえます。\nさらに、 #レッズ飯 でツイートすることで、さらにポイントが手に入ります！\nレッズ飯店舗へのチェックインは、試合開催日以外も可能です。同じ店舗にチェックインできるのは、1人あたり1日1回までです。',
      isOpen: false
    },
    {
      question: 'スタジアムやレッズ飯店舗以外でチェックインできるところはある？',
      answer:
        '浦和駅前にある浦和レッズオフィシャルショップのレッドボルテージ、浦和レッズの選手がトレーニングを行っている大原サッカー場でも毎日チェックインができます。チェックインをすると、10ポイントもらえます。',
      isOpen: false
    },
    {
      question: 'ポイントを貯めたらどうすればいい？',
      answer: 'ポイントと引き換えに交換できる特典は、[特典一覧ページ](/benefits)をご覧ください。',
      isOpen: false
    },
    {
      question: 'クリアファイルの引き換えはどこでできるの？',
      answer:
        'クリアファイルの引き換えは、レッズ飯店舗にて行っています。対象店舗につきましては、レッズ飯Mapをご覧ください。\n\nまた、オフィシャルショップのレッドボルテージでも6月20日以降クリアファイルの引き換えに対応します。',
      isOpen: false
    },
    {
      question: '使い方がわからない、エラーが出てきた',
      answer: '専用のお問い合わせ窓口を用意しております。\nお問い合わせフォームは[こちらから](https://forms.gle/us4QCrEDu4ZJ7dNY6)',
      isOpen: false
    }
  ]
}

export const mutations: Mutations = {
  selectItem(state: State, payload: { index: number }) {
    state.items = state.items.map((item, n) => ({ ...item, isOpen: n === payload.index ? !item.isOpen : item.isOpen }))
  }
}

export const actions: Actions = {
  async selectItem({ commit }, payload: { index: number }) {
    commit('selectItem', payload)
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
